export default "__VITE_ASSET__Rs3IACL7__"